"use client"

import Clarity from "@microsoft/clarity"
import { usePathname } from "next/navigation"
import { useEffect } from "react"

import { isClarityRouteEligible } from "./clarity-eligibility"

type ClarityConfig = {
  enabled: boolean
  project_id: string | null
}

const CLARITY_PROJECT_ID = /^[A-Za-z0-9_-]{1,128}$/

let initializedProjectId: string | null = null

function initializeClarityOnce(config: ClarityConfig): void {
  const projectId =
    typeof config.project_id === "string" ? config.project_id.trim() : ""

  if (!config.enabled || !CLARITY_PROJECT_ID.test(projectId)) return
  if (initializedProjectId === projectId) return
  if (initializedProjectId && initializedProjectId !== projectId) return

  try {
    Clarity.init(projectId)
    initializedProjectId = projectId
  } catch {
    // Clarity is optional telemetry and must never affect application behavior.
  }
}

export default function ClarityRuntime({ config }: { config: ClarityConfig }) {
  const pathname = usePathname() || "/"

  useEffect(() => {
    if (!isClarityRouteEligible(pathname)) return
    initializeClarityOnce(config)
  }, [config.enabled, config.project_id, pathname])

  return null
}
